export function startAsync(callback: () => void) {
  (async () => {
    callback();
  })();
}

export function delay(ms: number): Promise<Function> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
